<script setup lang="ts">
</script>

<template>
  <span class="user-select-none rounded-xl bg-primary px-1 text-xs text-white">
    <slot />
  </span>
</template>

<style scoped>

</style>
